import React, { useContext, useEffect, useState } from "react";
import crownGolden from "../../images/crown_golden.png";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";
import { AnimatePresence, motion } from "framer-motion";

export default function Vip({ id, isVip, callingFrom = null }) {
  const [isVipPopup, setIsVipPopup] = useState(false);
  const [isVipGolden, setIsVipGolden] = useState("");
  const { API_URL } = useContext(UrlContext);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    if (isVip === "yes") {
      setIsVipGolden("yes");
    } else {
      setIsVipGolden("no");
    }
  }, [isVip]);

  const handleIsVip = () => {
    const url = `${API_URL}save-expert-vip`;
    const data = {
      expertID: id,
      isVip: isVipGolden === "yes" ? "no" : "yes",
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Success",
            showConfirmButton: false,
            timer: 1500,
          });
          setIsVipPopup(false);
          if (isVipGolden === "yes") {
            setIsVipGolden("no");
          } else {
            setIsVipGolden("yes");
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            confirmButtonColor: "#365565"
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          confirmButtonColor: "#365565"
        });
      });
  };

  return (
    <>
      <div
        className="relative flex items-center"
        onMouseEnter={() => setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
      >
        {isVipGolden === "yes" ? (
          <i class="fa-solid fa-crown" style={{color: "gold", fontSize: callingFrom==='stickyBar' ? null : "24px", marginTop: "1px", cursor: "pointer"}} onClick={() => setIsVipPopup(true)}></i>
        ) : (
          <i class="fa-solid fa-crown" style={{color: "lightgrey", fontSize: callingFrom==='stickyBar' ? null : "24px", marginTop: "1px", cursor: "pointer"}} onClick={handleIsVip}></i>
        )}
        {/* Tooltip (with Framer Motion) */}
        <AnimatePresence>
          {tooltipOpen && (
            <motion.div
              className={`absolute ${callingFrom==='stickyBar' ? 'top-0 left-5' : '-top-7 -left-10'} -translate-x-1/2 bg-[#365561] text-white text-xs px-2 py-1 rounded shadow-md whitespace-nowrap z-50 pointer-events-none`}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.3 }}
            >
              {isVipGolden === "yes" ? (
                <span>Remove from Top Consultants</span>
              ) : (
                <span>Add to Top Consultants</span>
              )}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      {isVipPopup && (
        <div className="removeVIP-popup-wrapper">
          <div className="tab-pane fade show removeVIP-div">
            <div>
              <center>
                <img src={crownGolden} width="50px" alt="" />
                <p>
                  Remove this expert from <strong>Top Consultants</strong> list?
                </p>
                <br />
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => setIsVipPopup(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={handleIsVip}
                >
                  Continue
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
    </>
  );
}